import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateMaternityLeaveForm } from "../../../components/create-maternity-leave-form";

export const MaternityLeaveCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin nghỉ thai sản">
      <CreateMaternityLeaveForm />
    </ProcedureLayout>
  );
});
